import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Arkansas = () => {
  return (
    <StatePropertyTaxPage
      stateName="Arkansas"
      processDescription="Appeals must be submitted to the County Equalization Board between August 1 and the third Monday in August. Appointments required for hearings."
      noticeOfValueMailed="July in re-appraisal years, April in other years"
      noticeOfValueMailedDateExplanation="Valuation notices are mailed in July in accordance with Equalization Board timelines during re-appraisal years which happen every five years beginning in 2022 (2027, 2032, etc). In non re-appraisal years the notices of value are sent with the tax bills in March or April."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Valuation date for Arkansas is January 1 of the assessment year as defined by Arkansas statutes. Properties are systematically re-appraised every five years to ensure current market values are reflected in assessments."
      deadlineExplanation="Property tax appeals are accepted only during a specific statutory window from August 1 to the third Monday in August. This brief appeal period requires property owners to act quickly once notices are received. All hearings require appointments and must be scheduled within this timeframe."
      stateStatute="https://law.justia.com/codes/arkansas/2020/title-26/subtitle-3/chapter-26/"
    />
  );
};

export default Arkansas;